import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import "primeicons/primeicons.css";
import { TabView, TabPanel } from "primereact/tabview";
import instance from "../../../api/api.js";
import { styleIcone } from "../../../shared";
import { IoMdEye } from "react-icons/io";
import { FiPlus } from "react-icons/fi";
import { MenuPoint } from "../../../shared/compoments";
import { GoPlus } from "react-icons/go";
import { IoPersonOutline } from "react-icons/io5";
import AllCompomentShared from "../../../shared/compoments/AllCompomentShared.jsx";
import { useNavigate } from "react-router-dom";

function ListeProprietaire() {
  const [proprietaire, setProprietaire] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const ITEMSFILTER = ["nom", "prenom", "phone", "email"];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  useEffect(() => {
    const getListProprietaire = async () => {
      try {
        const response = await instance.get("prorietaires");
        console.log("Proprietaire", response);
        setProprietaire(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getListProprietaire();
  }, []);

  return (
    <AllCompomentShared
      libelleHeaderComp={"Liste des propriétaires"}
      titleStatisticHeaderComp={"Nombre de propriétaires"}
      nbreTotalStatistiqueComp={proprietaire.length}
      SearchTableLibelleBtn={"Nouveau propriétaire"}
      SearchTableIsBtn={true}
      SearchTableIsSearch={true}
      placeholderInputSearch={"Recherche"}
      globalFilterValue={globalFilterValue}
      onGlobalFilterChange={onGlobalFilterChange}
      SearchTableNameRouteBtn={"/proprietaire/enregistrement"}
      SearchTableIconeBtn={<GoPlus />} //import { GoPlus } from "react-icons/go";
      iconeStatistiqueHeader={<IoPersonOutline fontSize={"2em"} />} //import { IoPersonOutline } from "react-icons/io5";
      isLoading={isLoading}>
      <ProprietaireDatatable
        items={proprietaire}
        itemsForFilter={ITEMSFILTER}
        filters={filters}
      />
    </AllCompomentShared>
  );
}
export function ProprietaireDatatable({ items, itemsForFilter, filters }) {
  const dt = useRef(null);
  const navigate = useNavigate();
  const options = [
    {
      name: "Voir plus",
      path: "/proprietaire/",
      icone: <IoMdEye style={styleIcone} />,
      isIdData: true,
    },
    {
      name: "Ajouter un bien",
      // path: "/creation-bien",
      icone: <FiPlus style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      methode: (idData) => {
        navigate("/proprietaire/bien/" + idData, {
          state: { message: "creation_bien_proprietaire" },
        });
      },
    },
  ];
  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };

  return (
    <div>
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={itemsForFilter}>
            <Column
              field="nom"
              style={{ textAlign: "center" }}
              header="Nom"></Column>
            <Column
              field="prenom"
              style={{ textAlign: "center" }}
              header="Prénoms"></Column>

            <Column
              field="phone"
              style={{ textAlign: "center" }}
              header="Téléphone"></Column>
            <Column
              field="email"
              style={{ textAlign: "center" }}
              header="Email"></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Actions"
              body={detailsInfo}></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ListeProprietaire;
